module.exports = __webpack_public_path__ + "static/media/Bandit-Screenshot-4.a8d484bd.png";